module.exports = __webpack_public_path__ + "static/media/inplayer-logo.d401573b.svg";